<template>
  <PopupTemplate>
    <p class="popup__title">{{ dataStore.promoTermsTitle }}</p>
    <p class="popup__description" v-html="dataStore.promoTermsText"></p>
  </PopupTemplate>
</template>

<script setup lang="ts">
import PopupTemplate from "@/components/popups/PopupTemplate.vue";
import { useDataStore } from "@/stores/data";

const dataStore = useDataStore();
</script>
